import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { TermsComponent } from '@out-web/components';

@Component({
  selector: 'out-term',
  imports: [CommonModule, TermsComponent],
  templateUrl: './term.component.html',
  styleUrl: './term.component.scss',
})
export class TermComponent implements OnInit {
  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit() {
    this.setMetaData();
  }

  setMetaData() {
    this.titleService.setTitle(
      'Terms and Conditions | Sell Your Tesla | Only Used Tesla'
    );
    this.meta.addTags([
      {
        name: 'description',
        property: 'description',
        content:
          'Terms and Conditions | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas',
        vmid: 'description',
      },
      {
        name: 'og:description',
        property: 'og:description',
        content:
          'Terms and Conditions | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas',
        hid: 'og:description',
      },
      {
        name: 'keywords',
        content:
          'Used Tesla, Buy Tesla Canada, Tesla Model 3, Tesla Model S, Used Electric Cars, Affordable Tesla, Certified Tesla',
      },
      {
        name: 'author',
        content: 'Only Used Tesla',
      },
    ]);
  }
}
